<template>
  <div class="box-forget">
    <el-form class="portal-form" :rules="rules" ref="elForm" :model="form">
      <el-form-item prop="phone">
        <el-input v-model="form.phone" placeholder="请输入您的手机号" />
      </el-form-item>
      <el-form-item prop="vcode">
        <sms-code v-model="form.vcode" :phone="form.phone" req-method="smsCode_resetPwd"></sms-code>
      </el-form-item>
    </el-form>
    <el-button type="primary" class="btn-ok btn-top" @click="onOK">确&nbsp;&nbsp;认</el-button>
  </div>
</template>

<script>
  import baseApi from '@/dss-common/api/base'
  import smsCode from './sms-code'

  export default {
    components: {
      smsCode
    },
    data() {
      return {
        form: {
          phone: '',
          vcode: ''
        },
        rules: {
          phone: {
            required: true,
            message: '请输入您的手机号'
          },
          vcode: {
            required: true,
            message: '请输入验证码'
          }
        }
      }
    },
    methods: {
      onOK() {
        this.$refs.elForm.validate(valid => {
          if (!valid) {
            return;
          }
          this.submit();
        });
      },
      submit() {
        baseApi.checkCode_resetPwd(this.form).done(()=> {
          this.$emit('ok');
        });
      }
    }
  }
</script>

<style lang="less" scoped>
.btn-ok{
    width: 308px;
    height: 54px;
    background: #2e8dff;
    border-radius: 4px;
    margin-top: 40px;
    font-size: 20px;
  }
</style>
